module.exports = __webpack_public_path__ + "media/images/logo-full-white-cb45392db5e41334f8382f49b9cac4de.png";